import React from 'react';
import Switch from 'react-switch';
import { useTheme } from '@/core/themes/ThemeContext';
import styled, { keyframes } from 'styled-components';
import { shade } from 'polished';
import { basicColor } from '@/styles/template';
import Icon from '@/components/atoms/UI/Icon/Icon';

// Анимация "восхода"
const slideUp = keyframes`
    from {
        transform: translateY(100%);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
`;

// Стилизованные обертки с анимацией и скрытием выходящих элементов
const IconWrapperLeft = styled.div<{ isActive: boolean }>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 5px;
    height: 100%;
    animation: ${({ isActive }) => (isActive ? slideUp : 'none')} 0.5s ease;
`;

const IconWrapperRight = styled.div<{ isActive: boolean }>`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 5px;
    height: 100%;
    animation: ${({ isActive }) => (isActive ? slideUp : 'none')} 0.5s ease;
`;

const Wrap = styled.div`
  & .switcher {
      overflow: hidden;
  }
`

const ThemeSwitcher: React.FC = () => {
    const { theme, toggleTheme } = useTheme();

    return (
        <Wrap>
            <Switch
                checked={theme.title === 'dark'}
                onChange={toggleTheme}
                uncheckedIcon={
                    <IconWrapperLeft isActive={theme.title !== 'dark'}>
                        <Icon name={'Moon'} small />
                    </IconWrapperLeft>
                }
                checkedIcon={
                    <IconWrapperRight isActive={theme.title === 'dark'}>
                        <Icon name={'Sun'} small />
                    </IconWrapperRight>
                }
                offColor={basicColor.deepDark}
                onColor={basicColor.accent}
                height={32}
                width={64}
                handleDiameter={24}
                boxShadow={'none'}
                className={'switcher'}
            />
        </Wrap>

    );
};

export default ThemeSwitcher;
